<script lang="ts" setup>
defineProps<{
  text?: string;
}>();
</script>
<template>
  <div v-if="text" class="horizontal-separator">
    <span>{{ text }}</span>
  </div>
  <!-- ENG-20665 native separator (replaces the Quasar separator) -->
  <hr v-else class="m-separator" />
</template>
<style lang="scss">
.m-separator {
  height: 1px;
  width: 100%;
  background-color: var(--border-translucent);
}
.horizontal-separator {
  display: flex;
  flex-direction: row;
  color: var(--grey-darkest);

  span {
    margin-left: var(--space-5);
    margin-right: var(--space-5);
  }

  &:before,
  &:after {
    content: " ";
    flex: 1 1;
    border: 1px solid var(--grey-light);
    margin: auto;
  }
}
</style>
